<template>
  <div class="w-full flex gap-2" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ label }}</div>
    <div class="flex-1">
      <vs-select class="w-full" autocomplete v-model="select" @change="change" :disabled="readonly">
        <vs-select-item v-for="(item, index) in list" :key="index" :text="getText(item)" :value="item.value" />
      </vs-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchNavItemSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: [Number, String],
    list: Array,
    size: {
      type: String,
      default: "normal",
    },
    readonly: Boolean,
    widthClass: String,
    name: {
      type: String,
      default: "searchType",
    }
  },
  watch: {
    value(value) {
      this.select = value;
    },
    list: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.value) {
          this.select = this.list[0].value;
          this.change(this.select);
        }
      },
    },
  },
  computed: {
    getSearchType () {
      const query = this.$route.query;
      if (query[this.name]) {
        try {
          return query[this.name]
        } catch (e) {}
      }
      return this.select
    },
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  data() {
    return {
      select: this.value,
    };
  },
  created() {
    // this.value 값이 비어 있으면, 첫번째 값으로 설정
    if (!this.value) {
      this.select = this.list[0].value;
      this.change(this.select);
    }

    this.select = this.getSearchType
    this.change(this.select);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
      this.$emit("change", data);
    },
    getText(item) {
      const result = item.text || item.value
      if (parseInt(this.projectId) === 2) {
        if (result === "사업장명") {
          return "부서";
        }
      } else if (parseInt(this.projectId) === 3) {
        if (result === "사업장명") {
          return "사업명";
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-right: 1rem;
  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 114px;
  }
}
</style>
